import { deleteApi, get, patch, post, put } from "../../config/api";

class StudioService {

    static async getRecipe(id) {
        const url = `/v3/dashboard/recipe/${id}`;
        return await get({ url });
    }

    static async getRecipes(data) {
        const url = "/v3/dashboard/recipe/paginated";
        return await post({ url, data })
    }

    static async createRecipe(data) {
        const url = "/v3/dashboard/recipe";
        return await post({ url, data })
    }

    static async getIngredients(data) {
        const url = "/v3/dashboard/ingredient/paginated";
        return await post({ url, data })
    }

    static async getIngredientData(id) {
        const url = `/v3/dashboard/ingredient/${id}`;
        return await get({ url });
    }

    static async createIngredient(data) {
        const url = `/v3/dashboard/ingredient`;
        return await post({ url, data })
    }

    static async updateIngredient(id, data) {
        const url = `/v3/dashboard/ingredient/${id}`;
        return await put({ url, data })
    }

    static async updateRecipe(id, data) {
        const url = `/v3/dashboard/recipe/${id}`;
        return await put({ url, data })
    }

    static async updateRecipeVerificationStatus(id, data) {
        const url = `/v3/dashboard/recipe/update/verified/${id}`;
        return await put({ url, data });
    }

    static async searchRecipes(keyword, data) {
        const url = `/v3/dashboard/recipe/search?keyword=${keyword}`;
        return await post({ url, data })
    }

    /**
     * Paginated dish list (v3 contract: GET /v3/dishes/pagination).
     * @param {{ page: number, limit?: number }} params
     */
    static async getDishesPaginated({ page, limit = 20 }) {
        const url = "/v3/dashboard/dish/pagination";
        return await get({ url, params: { page, limit } });
    }

    /**
     * Search dishes by title (v3: min keyword length 3 on server).
     * @param {string} query
     */
    static async searchDishesByTitle(query) {
        const url = "/v3/dashboard/dish/search";
        return await get({ url, params: { query } });
    }

    /**
     * Get one dish. Normalizes v3 shape `{ dish, canDelete, canUpdate }` and legacy array responses.
     * @param {string} dishId
     */
    static async getDish(dishId) {
        const url = `/v3/dashboard/dish/${dishId}`;
        return await get({ url });
    }

    /**
     * Create dish (v3: POST /v3/dish).
     * @param {object} data — CreateDishInputDto
     */
    static async createDish(data) {
        const url = "/v3/dashboard/dish/create";
        return await post({ url, data });
    }

    /**
     * Update dish (v3: PATCH /v3/dashboard/dish/update/:dishId).
     * @param {string} dishId
     * @param {object} data
     */
    static async updateDish(dishId, data) {
        const url = `/v3/dashboard/dish/update/${dishId}`;
        return await patch({ url, data });
    }

    /**
     * Delete dish (DELETE /v3/dashboard/dish/delete/:dishId).
     * @param {string} dishId
     */
    static async deleteDish(dishId) {
        const url = `/v3/dashboard/dish/delete/${dishId}`;
        return await deleteApi({ url });
    }

    /**
     * Optional: recipes linked to a dish (legacy path; not part of dish v3 contract).
     * @param {string} dishId
     */
    static async getRecipesForDish(dishId) {
        const url = `/v3/dashboard/dish/${dishId}/recipe`;
        return await get({ url });
    }

}

export default StudioService;